import { types } from 'mobx-state-tree';

export const FavoriteEventInfo = types
    .model({
        eventId: types.number,
        missingIteration: types.optional(types.number, 0)
    }).actions((self) => ({
        increaseMissing: () => {
            self.missingIteration++;
        }
    })
    );

